import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import CSSModule from 'react-css-modules';
import { Link } from 'react-router';
import $ from 'jquery';

import { getPackageList, getRetail } from '../../actions';

import Button from '../../component/button';
import Title from '../../component/title';

class Recharge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        }
        this.handleClick = (e) => {
        }
    }   
    componentDidMount() {
        this.props.getPackageList().then((res => {
            this.setState({
                list: res
            })
        }));;
        this.props.getRetail().then((res => {
            //console.log(res);
        }));
    }
    render() {
        const { list } = this.state;
        const type = this.props.user.level === 2 ? 'vip': 'normal';

        return (
            <div styleName="container">
                <Title icon="recharge" styleName="title">儲值</Title>
                <p>儲值 12 點以上就可以開始預約報名課程固定生，每點代表一般課程 30 分鐘的使用時間，一般課程 1 小時 30 分鐘使用 3 點，或是 1 小時課程使用 2 點，特殊課程點數可能不同。</p>
                <br/>
                <br/>
                <p>{ this.props.user.level === 2 ? 'VIP':'一般'}會員價格：</p>
                <br/>
                <br/>
                <Link to="/product/0"><Button onClick={this.handleClick.bind(this, 1)} styleName="button">零售點數</Button></Link>
                { list && list.map((object, key)=>{
                    //console.log(object);
                    if(object.type === type && !object.disable ){
                        return(
                            <Link to={`/product/${object.id}`} key={object.id}><Button styleName="button">{object.name}</Button></Link>
                        );   
                    }
                })}
            </div>
        );
    }
}

const mapStateToProps = state => {
	return {
        user: state.data.user
    }
}

export default connect(mapStateToProps, { getPackageList, getRetail })(CSSModule(Recharge,style,{allowMultiple:true}));


/** WEBPACK FOOTER **
 ** ./src/container/recharge/index.js
 **/